import React, { useEffect, useState } from "react";
import { AdminSidebar, EmpSidebar } from "./SidebarData";
import SubMenu from "./SubMenu";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import NavBar from "../Navbar/";
import { getInitials } from '../../assets';
import { useAuth } from "../../Navigation/Auth/ProvideAuth";

const Sidebar = () => {
  const [sideBar, setSideBar] = useState(false);
  
  const showSidebar = () => {
    setSideBar(!sideBar);
  };
  
  const auth = useAuth();
  const ref = React.useRef(null);

  

  useEffect(() => {
    function handleClickOutside(event) {
      if (!ref.current.contains(event.target) && event.target.name !== "menuBtn") {
        setSideBar(false)
        // console.log(sideBar,"check sidebar status")
      }
      if(ref.current.contains(event.target)){
        setSideBar(true)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  

  return (
    <>
      <NavBar
        showMenuBtn={true}
        showSidebar={showSidebar}
        getInitials={getInitials(`${auth.user.firstName} ${auth.user.lastName}`)}
      />
      <div ref={ref} className={`sidebar ${sideBar ? "" : "disappear"}`} >
        <div className="InfoContainer">
          <div className="UserImage">
            <p className="initial-name">
              {getInitials(`${auth.user.firstName} ${auth.user.lastName}`)}
            </p>
          </div>
          <div className="Info">
            <Link className="InfoName" to="#">
              {`${auth.user.firstName} ${auth.user.lastName}`}
            </Link>
            <div>
              <span className="dot"></span>
              <span className="userStatus">{"Online"}</span>
            </div>
          </div>
        </div>
        <hr />
        {
          auth.user.mainUserId === 2 ? (
            AdminSidebar.map((item, index) => {
              return <SubMenu
                showMenuBtn={true}
                sideBar={sideBar}
                showSidebar={showSidebar}
                getInitials={getInitials(`${auth.user.firstName} ${auth.user.lastName}`)}
                item={item}
                setSideBar={setSideBar}
                key={index} />;
            })
          ) : (
            EmpSidebar.map((item, index) => {
              return <SubMenu
                showMenuBtn={true}
                sideBar={sideBar}
                showSidebar={showSidebar}
                getInitials={getInitials(`${auth.user.firstName} ${auth.user.lastName}`)}
                item={item}
                setSideBar={setSideBar}
                key={index} />;
            })
          )
        }
        <hr />
        <h6 className="quickLinkInfo">{"Quick Links"}</h6>
        <Link to="#" className="quickLinkContent">
          <FontAwesomeIcon icon={faLink} />
          <p>{'Vision Collab'}</p>
        </Link>
        {/* <SignOut /> */}
      </div>
    </>
  );
};

export default Sidebar;
